/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiGetGroupReservationWaitTimeResponseFromJSON(json) {
    return StreemApiGetGroupReservationWaitTimeResponseFromJSONTyped(json, false);
}
export function StreemApiGetGroupReservationWaitTimeResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'estimatedWaitTime': !exists(json, 'estimated_wait_time') ? undefined : (new Date(json['estimated_wait_time'])),
    };
}
export function StreemApiGetGroupReservationWaitTimeResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'estimated_wait_time': value.estimatedWaitTime === undefined ? undefined : (value.estimatedWaitTime.toISOString()),
    };
}
//# sourceMappingURL=StreemApiGetGroupReservationWaitTimeResponse.js.map